<template>
    <div class="scrollableArea">
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-8 d-flex px-0 text-center bg-darker dark font-weight-600">
                    <div class="col-sm-4 px-0 py-3 text-uppercase pointer" :class="{'selectedTab':tab.selected, 'centerTab':tab.centerTab, 'opacity-50': !tab.enabled()}" @click="changeTab(tab)" v-for="tab in tabs">{{tab.label}}</div>
                </div>

                <div class="col-sm-4">
                    <div class="row h-100">
                        <div class="col-sm-12 px-0 py-3 text-center bg-darkest lightest font-weight-600">Summary</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid scrollThis">
            <div class="row h-100" v-if="reservation.product.id">
                <div class="col-sm-8 bg-lighter">
                    <div :is="visibleArea" :reservation="reservation"></div>
                </div>

                <div class="col-sm-4 mb-3">
                    <reservation-summary :reservation="reservation" :selectedAgentComissions="selectedAgentComissions"></reservation-summary>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { reservationsMixin } from '@/mixins/reservations'

    import navigator from './Resume/Navigator'
    import ResumeDetails from './Resume/Details'
    import ResumeAddTransport from './Resume/AddTransport'
    import ResumeAddExtra from './Resume/AddExtra'
    import ReservationSummary from './Resume/ReservationSummary'

    export default {
        mixins: [ 
            reservationsMixin 
        ],
        data() {
            return {
                reservation: null,
                tabs: [
                    {
                        label: 'Details',
                        component: 'resume-details',
                        selected: true,
                        enabled: function () {
                            return true;
                        }
                    },
                    {
                        label: 'Add Transport',
                        component: 'resume-add-transport',
                        centerTab: true,
                        selected: false,
                        enabled: this.enableTransports
                    },
                    {
                        label: 'Add Extra',
                        component: 'resume-add-extra',
                        selected: false,
                        enabled: this.enableComponents
                    }
                ],
                selectedAgentComissions: null,
                visibleArea: 'resume-details'

            }
        },
        created() {
            this.resetReservation();

            // Set reservation
            this.reservation = this.getReservation

            // If there is no product selected (ex.: if F5 is pressed) send to calendar
            if(!this.reservation.product.id){
                this.$router.push('/calendar');
                
                return false;
            }

            // Get reservation id
            this.getReservationSequencialNumber()

            this.reservation.bookingComponents = [];
            if (this.reservation.event.eventGenderPrices) {
                this.reservation.bookingGenderPrices = JSON.parse(JSON.stringify(this.reservation.event.eventGenderPrices));
                
                for (let genderPrice of this.reservation.bookingGenderPrices) {
                    if (genderPrice.genderPriceType == 1 && genderPrice.isExcludedFromBilling == false) {
                        if (this.reservation.bookingGenderPrices.some(gp => gp.audienceType !== null) && genderPrice.audienceType === null) {
                            genderPrice.quantityToBook = 0;
                        } else {
                            genderPrice.quantityToBook = 1;
                        }
                    } else {
                        genderPrice.quantityToBook = 0;
                    }
                }
            }

            if (this.reservation.event.eventComponents) {     
                for (let eventComponent of this.reservation.event.eventComponents) {
                    if (eventComponent.component.componentType === 1) {
                        eventComponent.originalQuantity = eventComponent.quantity;
                    }
                }
            }

            if (this.$route.params.id) {
                alert(this.$route.params.id);
            }

            // Gets calcultions for this reservations with 0 totals
            this.setReservationCalculations(this.reservation);

            // Check if the event has mandatory extras and show them as a popup
            this.showMandatoryExtras(this.reservation);

            // Cleans calculationsGUID as this is a new reservation
            this.resetCalculationsGuid();

            // Add billing list item 0 to use the billing details
            this.$set(this.reservation, 'billingList', [
                {
                    details: {
                        address: null,
                        businessName: null,
                        city: null,
                        country: null,
                        vat: null
                    }
                }
            ]);

            // Set default resource
            this.setResource();

            // Download Selected product commissions
            this.downloadSelectedProductCommissions(this.reservation.event.product.id);

            // Do not auto-add a passenger for price-per-order products. Require user to add a passenger explicitly.
        },
        computed: {
            ...mapGetters([
                'getReservation',
            ]),
            isPricePerOrder() {
                return this.reservation.bookingGenderPrices[0].genderPriceType == 1;
            }
        },
        methods: {
            ...mapActions([
                'resetReservation',
                'setReservationCalculations',
                'resetCalculationsGuid',
                'downloadSelectedProductCommissions',
                'getNumberForNewReservation'
            ]),
            enableTransports() {
                return this.loggedUserAccessList.channel? this.loggedUserAccessList.channel.isAllowedSellTransports : false;
            },
            enableComponents() {
                return this.loggedUserAccessList.channel? this.loggedUserAccessList.channel.isAllowedSellComponents : false;
            },
            changeTab(tab) {
                if (!tab.enabled()) {
                    this.$toasted.error('Access restricted');
                    
                    return false;
                }

                // Deselect all tabs
                for (let iTab of this.tabs) {
                    iTab.selected = false;
                }

                this.visibleArea = tab.component;
                tab.selected = true;
            },
            agentComissionsChanged(data) {
                this.selectedAgentComissions = data;
            },
            setResource() {
                this.$set(this.reservation, 'selectedResource', this.resourcesWithAvailability[0]);
            },
            getReservationSequencialNumber() {
                this.getNumberForNewReservation().then(response => {
                    if (response.status == 200) {
                        this.$set(this.reservation, 'sequencialNumber', response.data);
                    }
                })
            }
        },
        components: {
            navigator,
            ResumeDetails,
            ResumeAddTransport,
            ResumeAddExtra,
            ReservationSummary,
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../assets/scss/_variables.scss";

    .scrollableArea {
        display: flex;
        height: 94vh;
        flex-direction: column;
        overflow: auto;

        .scrollThis {
            overflow: auto;
            height: 100%;
        }
    }

    .selectedTab {
        color: $lightest;
        border-bottom: 4px solid $color-6;
    }

    .centerTab {
        border-left: 2px solid $darkest;
        border-right: 2px solid $darkest;
    }
</style>



// WEBPACK FOOTER //
// Resume.vue?6f71c690